import classnames from 'classnames';

import ZpButton from 'components/zpButton';

import classes from './index.module.css';

export const SignInButton = ({ onSignIn, title = 'Log In', className }) => (
  <ZpButton
    theme="primary"
    size="big"
    type="button"
    className={classnames('custom-btn', classes.signBtn, classes.signIn, className)}
    onClick={onSignIn}
    isFullWidth={className?.includes('w-100')}
  >
    {title}
  </ZpButton>
);

export const SignUpButton = ({ onSignUp, className }) => (
  <ZpButton
    theme="primary"
    size="big"
    type="button"
    className={classnames('custom-btn', classes.signBtn, classes.signUp, className)}
    onClick={onSignUp}
    isFullWidth={className?.includes('w-100')}
  >
    Sign Up
  </ZpButton>
);

export const AuthMenu = ({ onSignUp, onSignIn, showMobile = false }) => (
  <div
    className={classnames('flex-column flex-lg-row align-items-center', {
      'd-none d-lg-flex': !showMobile,
      'd-flex': showMobile,
    })}
  >
    <SignInButton onSignIn={onSignIn} className={showMobile ? 'w-100' : ''} />
    <SignUpButton onSignUp={onSignUp} className={showMobile ? 'w-100' : ''} />
  </div>
);
